// src/hooks/usePortal.js
import { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";

export default function usePortal(active = false, onClose = () => {}) {
  const [container, setContainer] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    if (!active) return;

    const el = document.createElement("div");
    el.style.position = "absolute";
    document.body.appendChild(el);
    setContainer(el);
    ref.current = el;

    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose(); // <-- Close if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
        try {
             ReactDOM.unmountComponentAtNode(el);
        } catch (error) {
            console.log("error while unmounting portal",error)
        }
     
      document.body.removeChild(el);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [active]);

  const renderPortal = (children) => {
    if (container) {
      return ReactDOM.createPortal(children, container);
    }
    return null;
  };

  return renderPortal;
}
